const COLORS = ['#2563eb', '#c2410c', '#087f70', '#9333b8', '#be185d', '#52651c', '#0369a1', '#9a6700'];
function localDate(date) {
    return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
}
function presetPeriod(name, now = new Date()) {
    const end = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    const start = new Date(end);
    if (name === 'month') start.setDate(1);
    else if (name === 'previous') { start.setMonth(start.getMonth() - 1, 1); end.setDate(0); }
    else start.setDate(start.getDate() - (name === '7' ? 6 : 29));
    return {start: localDate(start), end: localDate(end)};
}
function storageKey(user) { return `argus.charts.v2:${user.company}:${user.userId || user.user_id || user.id}`; }
function defaults() { return {...presetPeriod('30'), primary: null, comparison: [], metric: 'workers', selections: {}, combine: false}; }
function restore(raw, objects, metrics) {
    const state = defaults();
    if (!raw || typeof raw !== 'object') return state;
    if (/^\d{4}-\d{2}-\d{2}$/.test(raw.start) && /^\d{4}-\d{2}-\d{2}$/.test(raw.end)) { state.start = raw.start; state.end = raw.end; }
    const allowed = new Set(objects.map(object => Number(object.building_process_id)));
    state.primary = raw.primary === 'all' ? 'all' : allowed.has(Number(raw.primary)) ? Number(raw.primary) : null;
    state.comparison = state.primary === 'all' ? [] : [...new Set((Array.isArray(raw.comparison) ? raw.comparison : []).map(Number))]
        .filter(id => allowed.has(id) && id !== state.primary);
    if (metrics.some(metric => metric.id === raw.metric)) state.metric = raw.metric;
    metrics.forEach(metric => {
        const values = raw.selections && raw.selections[metric.id];
        state.selections[metric.id] = Array.isArray(values) ? [...new Set(values.map(Number).filter(id => Number.isSafeInteger(id) && id > 0))].slice(0, 100) : [];
    });
    // Combining is an explicit action for the current visit, never inherited from saved filters.
    return state;
}
function groupPlots(series) {
    const groups = new Map();
    series.forEach(item => {
        // Selection IDs are independent of the object: objects are compared only within the same work/group.
        const selection = item.item_ids ? item.item_ids.join(',') : item.id.split(':').slice(2, -1).join(':');
        const key = `${selection}:${item.unit_key}`;
        if (!groups.has(key)) groups.set(key, {key, name: item.name, unit: item.unit, series: []});
        groups.get(key).series.push(item);
    });
    return [...groups.values()];
}
function colorFor(id) { let hash = 0; for (const char of String(id)) hash = ((hash * 31) + char.charCodeAt(0)) >>> 0; return COLORS[hash % COLORS.length]; }
function colorsFor(series, previous = {}) {
    const colors = {...previous}, used = new Set(Object.values(previous).map(color => COLORS.indexOf(color)));
    [...series].sort((a, b) => a.id.localeCompare(b.id)).forEach(item => {
        if (colors[item.id]) return;
        let index = COLORS.indexOf(colorFor(item.id));
        if (used.size < COLORS.length) while (used.has(index)) index = (index + 1) % COLORS.length;
        used.add(index); colors[item.id] = COLORS[index];
    });
    return colors;
}
function csvCell(value) {
    let text = value === null || value === undefined ? '' : String(value);
    if (/^[=+@\t\r]/.test(text) || /^-\D/.test(text)) text = `'${text}`;
    return `"${text.replace(/"/g, '""')}"`;
}
function exportCsv(series, offset) {
    const rows = [['Объект', 'Показатель', 'Единица', 'Дата', 'День от старта', 'Значение', 'Числитель', 'Знаменатель', 'Отчётов за день']];
    series.forEach(item => item.points.filter(point => !offset || point.day >= 1).forEach(point => rows.push([
        item.object_name, item.name, item.unit, point.date, point.day, point.value, point.numerator, point.denominator, point.reports_count
    ])));
    return '\uFEFF' + rows.map(row => row.map(csvCell).join(';')).join('\r\n');
}
// Invalidation is immediate: even during debounce an old response cannot be applied.
function requestGate() { let revision = 0; return {next: () => ++revision, current: value => value === revision}; }
module.exports = {localDate, presetPeriod, storageKey, defaults, restore, groupPlots, colorsFor, exportCsv, requestGate};
